module.exports = __webpack_public_path__ + "media/images/resize-2e4b79615ab809eeab5451a1e73164a9.svg";